import React, { useEffect } from "react"
import { useReportInfoModal } from "Pages/ReportsAlerts/Reports/@hooks"
import { Grid, Skeleton, Typography } from "@mui/material"
import ReportInfoModalTabs from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/Tabs"
import ReportInfoModalDetails from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/Details"
import { isEmpty } from "@ui-seeker/utils"
import { INFO_MODAL_TABS, REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"
import { selectedInfoModalTab, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import ReportListHistoricalModal from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/History"
import RatingHistoricalContent from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/History/RatingContent"


export default function ReportInfoModalContent() {


	const { data, isLoading, setIsLoading } = useReportInfoModal()
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING

	useEffect(() => {
		setIsLoading()
	}, [])

	return <Grid container spacing={2} sx={{ height: "70vh" }}>
		{isLoading && <Grid item xs={12}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Skeleton variant="rectangular" sx={{ height: "25px" }}/>
				</Grid>
				<Grid item xs={6}>
					<Skeleton variant="rectangular" sx={{ height: "50px" }}/>
				</Grid>
				<Grid item xs={6}>
					<Skeleton variant="rectangular" sx={{ height: "50px" }}/>
				</Grid>
				<Grid item xs={12}>
					<Skeleton variant="rectangular" sx={{ height: "50vh" }}/>
				</Grid>
			</Grid>
		</Grid>}
		{(!isLoading && !isEmpty(data)) && <Grid item xs={12}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h5">{`${data.name} Report Info`}</Typography>
				</Grid>
				<Grid item xs={12}>
					<ReportInfoModalTabs timestampLastExecution={data?.timestampLastExecution}/>
				</Grid>
				{selectedInfoModalTab.value === INFO_MODAL_TABS.DETAILS && <Grid item xs={12}>
					<ReportInfoModalDetails data={data}/>
				</Grid>}
				{selectedInfoModalTab.value === INFO_MODAL_TABS.HISTORY && <Grid item xs={12}>
					{isRating
						? <RatingHistoricalContent idReport={data.idReport}/>
						: <ReportListHistoricalModal idReport={data.idReport}/>
					}
				</Grid>}
			</Grid>
		</Grid>}
	</Grid>

}